/** @format */

import { ATC_BUTTON_TEXTS, selectAtcFulfillmentOption, selectProductSelectionState } from '@pdp/add-to-cart/data-access';
import {
	selectAllProductStyle,
	selectBundleInStorePickupButtonText,
	selectBundleShipToMeButtonText,
	selectSelectedPersonalizationOptions,
	selectcustomProductData
} from '@pdp/data-access/state';

import { createSelector } from '@ngrx/store';

/**
 * @description Add to Cart Button
 * Handles each different product scenario for the add to cart button
 * Currently add to cart button is used below fulfillment buttons and this will select
 * the text and enabled/disabled state for the button
 */

export const selectAddToCartButtonText = createSelector(
	selectAtcFulfillmentOption,
	selectBundleShipToMeButtonText,
	selectBundleInStorePickupButtonText,
	selectAllProductStyle,
	selectcustomProductData,
	selectSelectedPersonalizationOptions,
	(
		shipMode,
		shipToMeText,
		InStorePickupText,
		productStyle,
		customProductData,
		selectedPersonalizationOptions
	) => {
		if (productStyle.isCustomizable && !customProductData) {
			return {
				addToCartButtonText: ATC_BUTTON_TEXTS.customize,
				addToCartButtonDisabled: false
			};
		} else if (productStyle.isPersonalizable && !selectedPersonalizationOptions.valid) {
			return {
				addToCartButtonText: ATC_BUTTON_TEXTS.atc,
				addToCartButtonDisabled: false,
				buttonAction: 'SelectOptions'
			};
		} else if (shipMode === 'shipToMe') {
			return shipToMeText;
		} else {
			return InStorePickupText;
		}
	}
);

export const selectUserInputQty = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.userInputQuantity
);
